import { Component } from '@opten/compiler/metadata/component';
import flatten from '@opten/array/flatten';
import { BasketProductItem, BasketProductVariantItem, Basket } from '../models/basket';
import toggleClass from '@opten/dom/toggle-class';
import getParentWithClass from '@opten/dom/get-parent-with-class';
import addClass from '@opten/dom/add-class';
import removeClass from '@opten/dom/remove-class';

@Component({ className: 'js-basket__total-quantity' })
export class BasketQuantityComponent {
	private _basketTotalQuantityElement: HTMLElement;
	private _basketTotalQuantityElementWrapper: HTMLElement;

	constructor(private element: HTMLElement) {
		this._basketTotalQuantityElement = element;
		this._basketTotalQuantityElementWrapper = getParentWithClass(element, 'js-basket__total-quantity__wrapper');
	}

	updateBasketQuantity(basket: Basket, showDropdown = false) {
		let countProducts = 0;
		if (basket && basket.items && basket.items.length > 0) {
			const products = flatten(basket.items.map(l => l.products)) as BasketProductItem[];
			const variants = flatten(products.map(p => p.variants)).filter(o => !!o) as BasketProductVariantItem[];
			if (variants && variants.length > 0) {
				variants.forEach(variant => (countProducts += variant.quantity));
			}
		}
		this._basketTotalQuantityElement.innerHTML = countProducts + '';
		toggleClass(this._basketTotalQuantityElement, 'd-none', countProducts < 1);
		if (showDropdown) {
			this.popupBasketDropdown();
		}
	}

	private popupBasketDropdown() {
		if (this._basketTotalQuantityElementWrapper) {
			addClass(this._basketTotalQuantityElementWrapper, 'is--visible');
			setTimeout(() => {
				removeClass(this._basketTotalQuantityElementWrapper, 'is--visible');
			}, 3500);
		}
	}
}
